/* eslint-disable prefer-destructuring */
const getDate = () => {
  const date = new Date();
  const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  const dateTimeFormat = new Intl.DateTimeFormat('en', {
    year: 'numeric',
    month: 'short'
  });
  const [{ value: month }, , { value: year }] = dateTimeFormat.formatToParts(lastDay);

  return `${month} ${year}`;
};

const removeCentsAddCommas = arg => {
  return Number(parseFloat(arg).toFixed(0)).toLocaleString('en', {
    minimumFractionDigits: 0
  });
};

const firstDate = firstRequested => {
  return firstRequested || 'Jul 2019';
};

const lastDate = lastRequested => {
  return lastRequested || getDate();
};

const digitFormatter = num => {
  if (num >= 1000000) {
    return `${(num / 1000000).toFixed(1).replace(/\.0$/, '')}M`;
  }
  if (num >= 1000) {
    return `${(num / 1000).toFixed(1).replace(/\.0$/, '')}K`;
  }
  return num.toFixed(0);
};

const createChartData = (elem, region) => {
  const regionLowerCase = () => {
    if (region === 'US') {
      return region.toLowerCase();
    }
    return region.charAt(0).toLowerCase() + region.slice(1);
  };

  const { month, line_data: rawLineData, bar_data: barData } = elem;
  const lineData = rawLineData[regionLowerCase(region)];

  return {
    month,
    lineData,
    lineDataLabel: `$${digitFormatter(lineData)}`,
    barData
  };
};

function percIncrease(pub, benchmark) {
  if(!pub && !benchmark){
    return 0
  }

  const percent = (100 * (pub - benchmark)) / benchmark;
  return Math.floor(percent);
}

const createChartCsvData = (elem, region) => {
  const { month, line_data: lineData, bar_data: totalStories } = elem;
  const allTrafficValue = `$${digitFormatter(lineData.all)}`;
  const usTrafficValue = `$${digitFormatter(lineData.us)}`;
  const canadaTrafficValue = `$${digitFormatter(lineData.canada)}`;
  const baseData = { 'Month-Year': month, 'Total Stories Published': totalStories };

  if (region === 'All') {
    return {
      ...baseData,
      'Total SEO Traffic Value: All Regions': allTrafficValue,
      'Total SEO Traffic Value: US': usTrafficValue,
      'Total SEO Traffic Value: Canada': canadaTrafficValue
    };
  }
  if (region === 'US') {
    return {
      ...baseData,
      'Total SEO Traffic Value: US': usTrafficValue
    };
  }
  if (region === 'Canada') {
    return {
      ...baseData,
      'Total SEO Traffic Value: Canada': canadaTrafficValue
    };
  }

  return baseData;
};

const generatePubStoriesLink = pubId => {
  const queryParams = { hide_filters: false, publications: pubId, content_value: 'none' };
  const searchParams = new URLSearchParams(queryParams);
  return `${window.origin}/stories/library?${searchParams.toString()}`;
};

export {
  removeCentsAddCommas,
  firstDate,
  lastDate,
  createChartData,
  createChartCsvData,
  percIncrease,
  generatePubStoriesLink
};



// WEBPACK FOOTER //
// ./app/javascript/app/components/value/utils.js